import { useState } from "react";
import ChapterMarker from "../ChapterMarker";
import ProjectCard from "../ProjectCard";
import ProjectModal from "../ProjectModal";
import { PROJECTS, SECTIONS } from "../../data/content";

export default function Projects() {
  const s = SECTIONS[3];
  const [active, setActive] = useState(null);

  return (
    <section
      id={s.id}
      style={{ minHeight: `${s.weight * 100}vh` }}
      className="relative flex flex-col justify-center px-6 md:px-12 lg:px-24 py-24"
      data-testid="section-projects"
    >
      <ChapterMarker number={s.number} label={s.label} />
      <div className="pointer-events-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
        {PROJECTS.map((p, i) => (
          <ProjectCard key={p.id} project={p} index={i} onOpen={setActive} />
        ))}
      </div>
      <ProjectModal project={active} onClose={() => setActive(null)} />
    </section>
  );
}
